import { useEffect, useState, type ReactNode } from "react";

/**
 * Money and state changes need a second, deliberate tap. The first press arms the button
 * ("Confirmer ?"), the second runs it; it disarms by itself after a few seconds.
 */
export function Act({ children, run, tone = "solid", disabled }: { children: ReactNode; run: () => Promise<unknown>; tone?: "solid" | "ghost" | "danger"; disabled?: boolean }) {
  const [armed, setArmed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => { if (!armed) return; const t = setTimeout(() => setArmed(false), 4000); return () => clearTimeout(t); }, [armed]);
  return (
    <span className="act">
      <button
        className={`btn ${tone} ${armed ? "armed" : ""}`}
        disabled={disabled || busy}
        onClick={async () => {
          if (!armed) { setArmed(true); return; }
          setBusy(true); setErr(null);
          try { await run(); } catch (e) { setErr((e as Error).message); } finally { setBusy(false); setArmed(false); }
        }}
      >
        {busy ? "…" : armed ? <>Confirmer ?</> : children}
      </button>
      {err && <span className="err small" role="alert">{err}</span>}
    </span>
  );
}

export const Empty = ({ children }: { children: ReactNode }) => <p className="empty">{children}</p>;
